import { createFileRoute } from "@tanstack/react-router";
import ChefBuddy from "../components/tk/pages/ChefBuddy";

const title = "Chef Buddy | The menu, in conversation | thatKorner";
const description = "Chef Buddy is the concierge inside the menu. Guests ask in 60+ languages, get allergen answers checked against the kitchen's signed matrix, and order from the table or the room.";

export const Route = createFileRoute("/chef-buddy")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.thatkorner.com/chef-buddy" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.thatkorner.com/chef-buddy" }],
  }),
  component: ChefBuddy,
});
